import React from 'react';
import { GenericListPage } from '../../../components/generic';
import type { EmbeddedInConfigurationHub } from '../../configuration-settings/models';
import { useAppStatuss, AppStatus } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC<EmbeddedInConfigurationHub> = ({ embedded }) => (
  <GenericListPage<AppStatus>
    useData={useAppStatuss}
    embedded={embedded}
    config={{
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }}
  />
);

export default List;
